import { ROUTER } from "../router/constants";

export const MoreSettingRoomData = [
    {
        id:1,
        image:'./assets/image/svg/logout.svg',
        link:'/'
    },
    {
        id:2,
        image:'./assets/image/svg/support.svg',
        link: 'tel:021589090'
    },
    {
        id:3,
        image:'./assets/image/svg/camera.svg',
        link:'/watch-room'
    },
    {
        id:4,
        image:'./assets/image/svg/setting.svg',
        link:ROUTER.SETTING_ROOM
    },

]